import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { Input, Select, FallbackImage, Render, Button, Viewer, Modal } from 'components';
import { RootState } from 'reducers';
import { Globals, Constants } from 'utils';
import { CameraIcon, CancelCircleIcon, CheckCircleIcon, PasswordActive, PasswordInactive, PDFIcon, UserIcon, ViewIcon, ArrowBottom } from 'assets/icons';
import { ProfileService } from 'services';
import ModalAddBankData from './modal-add';
import moment from 'moment';

const TAB = {
	INFO: 1,
	BANK: 2,
}

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class Profile extends React.Component<Props> {

	state = {
		tab: TAB.INFO,
		form: {
			name: '',
			phone: '',
			email: '',
			city: '',
			password: '',
			password_confirmation: '',
			phoneprefix_id: ''
		},
		user: null,
		activePassword: false,
		file: null,
		visible: false,
		pdfUrl: '',
		pdfVisible: false,
		bank_data: [],
		banks: [],
		payment_methods: [],
		visible_bank_data: false,
		item: null,
		phoneprefixes: []
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Mi Perfil',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading = false) => {
		const res: any = await ProfileService.get({
			withoutLoading
		});
		this.setState({
			user: res.user,
			banks: res.banks || [],
			bank_data: res.bank_data,
			payment_methods: res.payment_methods || [],
			phoneprefixes: res.phoneprefixes || [],
			form: {
				...this.state.form,
				name: res.user?.name || '',
				phone: res.user?.phone || '',
				email: res.user?.email || '',
				city: res.user?.city || '',
				phoneprefix_id: res.user?.phoneprefix || Constants.PHONEPREFIX.VE
			}
		});
	}

	setTab = (tab: number) => {
		this.setState({ tab });
	}

	submit = async (e: any) => {
		e.preventDefault();
		const res: any = await ProfileService.save({
			...this.state.form,
		});
		Globals.showSuccess("Se ha actualizado el perfil correctamente");
		if (res.user) {
			this.props.dispatch({
				type: 'SET_USER',
				payload: res.user
			});
		}
		this.setState({
			form: {
				...this.state.form,
				password: '',
        		password_confirmation: '',
			}
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	changeFile = async (e: any, document_type_id: string | number) => {
		if (!e.target.files?.length) return;
		
		const file = e.target.files[0];
		e.target.value = '';

		const res: any = await ProfileService.changeFile({
			user_id: this.props.user?.id,
			hasFile: true,
			file,
			document_type_id
		});
		Globals.showSuccess("Se ha actualizado el documento");
		if (res.user) {
			await this.props.dispatch({
				type: 'SET_USER',
				payload: res.user
			});
		}
		this.load(true);
	}

	deleteAccount = () => {
		Globals.confirm('¿Desea eliminar la empresa? Esta acción no se puede deshacer.',async () => {
			await ProfileService.deleteAccount();
			this.props.dispatch({ type: 'SET_USER', payload: null });
			this.props.dispatch({ type: 'SET_ACCESS_TOKEN', payload: null });
			this.props.history.replace('/login');
		});
	}

	viewFile = (file: string) => {
		if (file.endsWith('.pdf')) {
			this.setState({
				pdfVisible: true,
				pdfUrl: file
			});
		}
		else {
			this.setState({
				visible: true,
				file
			});
		}		
	}

	addBankData = () => {
		this.setState({
			visible_bank_data: true
		});
	}

	onClose = () => {
		this.setState({
			visible_bank_data: false,
			item: null
		},() => {
			this.load(true);
		});
	}

	delete = (item: any) => {
		Globals.confirm('¿Desea eliminar la cuenta bancaria?',async () => {
			await ProfileService.deleteBankData({
				bank_data_id: item?.id
			});
			this.load(true);
		});
	}

	edit = (item: any) => {
		this.setState({
			visible_bank_data: true,
			item
		});
	}

	setDefault = async (item: any) => {
		await ProfileService.setDefaultBankData({
			bank_data_id: item?.id,
			withoutLoading: true
		});
		let bank_data: any = [...this.state.bank_data];
		for (let i = 0; i < bank_data.length; i++) {
			if (bank_data[i].id == item?.id) {
				bank_data[i].default = true;
			}
			else {
				bank_data[i].default = false;
			}
		}
		await this.setState({
			bank_data
		});
		this.load(true);
	}

	render() {
		const { tab, visible, bank_data, visible_bank_data } = this.state;
		const user: any = this.state.user;
		const rif_file = user?.user_documents?.find((i: any) => i.document_type_id == Constants.DOCUMENT_TYPES.RIF)?.file;
		const incorporation_file = user?.user_documents?.find((i: any) => i.document_type_id == Constants.DOCUMENT_TYPES.INCORPORATION)?.file;
		const photo_file = user?.user_documents?.find((i: any) => i.document_type_id == Constants.DOCUMENT_TYPES.PHOTO)?.file;
		const prefix = this.state.phoneprefixes.find((i: any) => i.id == this.state.form.phoneprefix_id);

		return (
			<div id="profile">
				<Viewer
			      visible={ visible }
			      onClose={ () => this.setState({ visible: false }) }
			      images={ [{ src: this.state.file }] }
			    />

			    <Modal
		          className="modal-add-bank-data"
		          visible={ visible_bank_data }
		          title={ `${ this.state.item ? 'Editar' : 'Añadir' } cuenta bancaria` }
		          onClose={ () => this.onClose() }
		        >
		        	{/*
		        	// @ts-ignore */}
		        	<ModalAddBankData
		        		onClose={ () => this.onClose() }
		        		banks={ this.state.banks }
		        		item={ this.state.item }
		        		payment_methods={ this.state.payment_methods }
		        	/>
		      	</Modal>

<Modal
  className="modal-pdf-viewer"
  visible={ this.state.pdfVisible }
  title="Visualizar PDF"
  onClose={ () => this.setState({ pdfVisible: false, pdfUrl: '' }) }
>
<div style={{ width: '100%', height: '70vh' }}>
<iframe 
src={ this.state.pdfUrl } 
style={{ width: '100%', height: '100%', border: 'none' }}
title="PDF Viewer"
/>
</div>
</Modal>

				<section>
					<div className="card">
						<div className="photo-wrapper">
							{
								user != null && (
									<FallbackImage
										src={Constants.BASE_STORAGE + photo_file}
										placeholder={UserIcon}
										className="fb-img"
										placeholderClassName="fb-img-placeholder"
									/>
								)
							}
						</div>

						<div className="actions">
							<label>
								<span>Adjuntar</span>
								<div className="button">
									<img src={CameraIcon} alt="" />
								</div>
								<input
									type="file"
									hidden
									onChange={e => this.changeFile(e,Constants.DOCUMENT_TYPES.PHOTO)}
									accept="image/jpeg,image/png"
								/>
							</label>
						</div>
					</div>
					<p className="card-foot">Logo representante / Logo Empresa</p>

					<div className="card">
						<div className="actions">
							<button className={!rif_file ? "danger" : "green"} disabled>
								<img src={rif_file ? CheckCircleIcon : CancelCircleIcon} alt="" />
							</button>

							<button disabled={ !rif_file } onClick={ () => this.viewFile(Constants.BASE_STORAGE + rif_file) }>
								<img src={PasswordInactive} alt="" />
							</button>

							{
								this.props.user?.level_id == Constants.LEVELS.CLIENT && (
									<label>
										<span>Adjuntar</span>
										<div className="button">
											<img src={PDFIcon} alt="" />
										</div>
										
										<input
											type="file"
											hidden
											onChange={e => this.changeFile(e,Constants.DOCUMENT_TYPES.RIF)}
											accept="image/jpeg,image/png,application/pdf"
										/>
									</label>
								)
							}
						</div>
					</div>
					<p className="card-foot">RIF Empresa</p>

					<div className="card">
						<div className="actions">
							<button className={!incorporation_file ? "danger" : "green"} disabled>
								<img src={incorporation_file ? CheckCircleIcon : CancelCircleIcon} alt="" />
							</button>

							<button disabled={ !incorporation_file } onClick={ () => this.viewFile(Constants.BASE_STORAGE + incorporation_file) }>
								<img src={PasswordInactive} alt="" />
							</button>

							{
								this.props.user?.level_id == Constants.LEVELS.CLIENT && (
									<label>
										<span>Adjuntar</span>
										<div className="button">
											<img src={PDFIcon} alt="" />
										</div>
										
										<input
											type="file"
											hidden
											onChange={e => this.changeFile(e,Constants.DOCUMENT_TYPES.INCORPORATION)}
											accept="image/jpeg,image/png,application/pdf"
										/>
									</label>
								)
							}
						</div>
					</div>
					<p className="card-foot">Documento Constitutivo</p>
				</section>

				<form onSubmit={this.submit}>
					<div className="tabs">
						<button
							type="button"
							className="tab"
							onClick={() => this.setTab(TAB.INFO)}
							data-active={String(tab === TAB.INFO)}
						>
							Información
						</button>

						<button
							type="button"
							className="tab"
							onClick={() => this.setTab(TAB.BANK)}
							data-active={String(tab === TAB.BANK)}
						>
							Datos Bancarios
						</button>
					</div>

					<Render condition={tab === TAB.INFO}>
						<div className="tab-content">
							<Input
								color="white"
								value={ this.state.form.name }
								name="name"
								label="Nombre"
								onChange={ this.change }
							/>
							<Input
								color="white"
								value={ this.state.form.city }
								name="city"
								label="Ciudad donde reside"
								onChange={ this.change }
							/>
							<Input
								color="white"
								value={ this.state.form.email }
								name="email"
								label="Correo Electrónico"
								onChange={ this.change }
							/>
							<div className="container-phone-select">
								<div className="container-select">
									{/* Queda pendiente instalar plugin para que sea realmente un select, por ahora esta desactivado */}
									<div className="select-disabled">
										{/*
										// @ts-ignore */}
										<img src={ Constants.BASE_PUBLIC + 'img/' + prefix?.icon } />
										<img src={ ArrowBottom } className="arrow" />
									</div>
								</div>
								<Input
									color="white"
									value={ this.state.form.phone }
									name="phone"
									label="Teléfono"
									onChange={ this.change }
								/>
							</div>

							<div>
								<p className="label-green">Cambiar contraseña</p>
							</div>

							<div />

							<Input
								type={ this.state.activePassword ? 'text' : 'password' }
								color="white"
								value={ this.state.form.password }
								name="password"
								label="Cambiar contraseña (Opcional)"
								placeholder="********"
								onChange={ this.change }
								searchRight
								searchIcon={ this.state.activePassword ? PasswordActive : PasswordInactive }
								onSubmit={ () => this.setState({ activePassword: !this.state.activePassword }) }
							/>
							<Input
								type={ this.state.activePassword ? 'text' : 'password' }
								color="white"
								value={ this.state.form.password_confirmation }
								name="password_confirmation"
								label="Repetir contraseña"
								placeholder="********"
								onChange={ this.change }
								searchRight
								searchIcon={ this.state.activePassword ? PasswordActive : PasswordInactive }
								onSubmit={ () => this.setState({ activePassword: !this.state.activePassword }) }
							/>
						</div>
					</Render>

					<Render condition={tab === TAB.BANK}>
						<div className="tab-content" style={{ display: 'block' }}>
							<button className="btn btn-add" type="button" onClick={ () => this.addBankData() }>
								<p>Agregar cuenta bancaria</p>
								<div className="add">
									+
								</div>
							</button>

							<div className="row">
								{
									bank_data?.map((item: any) => {
										return (
											<div className="col-md-6">
												<div className="bank-data-item">
													<button className="btn btn-payment-method" disabled type="button">
														{ item?.payment_method?.name }
														<img src={ Constants.BASE_PUBLIC + 'img/' + item?.payment_method?.icon } />
													</button>
													<p>Cuenta agregada el { moment(item?.created_at).format('DD/MM/YYYY') }</p>
													{
														item?.payment_method_id == Constants.PAYMENT_METHODS.PAYMENT_MOBILE && (
															<>
																<Input
																	color="white"
																	type="number"
																	value={ item?.phone }
																	name="phone"
																	label="Teléfono"
																	disabled={ true }
																	notMui
																	maxLength={ 11 }
																/>
																<Input
																	color="white"
																	value={ item?.document }
																	name="document"
																	label="Nº de Cédula/RIF"
																	disabled={ true }
																	notMui
																/>
																<Select
																	name="bank_id"
																	label="Banco"
																	disabled={ true }
																	value={ item?.bank_id }
																	options={ this.state.banks?.map((item: any) => {
																		return {
																			value: item.id,
																			label: item.name
																		}
																	}) }
																/>
															</>
														)
													}

													{
														item?.payment_method_id == Constants.PAYMENT_METHODS.TRANSFER && (
															<>
																<Input
																	color="white"
																	value={ item?.address }
																	name="address"
																	label="Número de cuenta"
																	disabled={ true }
																	notMui
																/>
																<Input
																	color="white"
																	value={ item?.document }
																	name="document"
																	label="Nº de Cédula/RIF"
																	disabled={ true }
																	notMui
																/>
																<Select
																	name="bank_id"
																	label="Banco"
																	disabled={ true }
																	value={ item?.bank_id }
																	options={ this.state.banks?.map((item: any) => {
																		return {
																			value: item.id,
																			label: item.name
																		}
																	}) }
																/>
															</>
														)
													}

													{
														item?.payment_method_id == Constants.PAYMENT_METHODS.ZELLE && (
															<>
																<Input
																	color="white"
																	value={ item?.name }
																	name="name"
																	label="Nombre"
																	disabled={ true }
																	notMui
																/>
																<Input
																	color="white"
																	value={ item?.email }
																	name="email"
																	label="Correo Electrónico"
																	disabled={ true }
																	notMui
																/>
															</>
														)
													}

													{
														item?.payment_method_id == Constants.PAYMENT_METHODS.BINANCE && (
															<Input
																color="white"
																value={ item?.email }
																name="email"
																label="Correo Electrónico"
																disabled={ true }
																notMui
															/>
														)
													}

													{
														item?.payment_method_id == Constants.PAYMENT_METHODS.BITCOIN && (
															<Input
																color="white"
																value={ item?.address }
																name="address"
																label="Billetera"
																notMui
																disabled={ true }
															/>
														)
													}

													{
														item?.payment_method_id == Constants.PAYMENT_METHODS.WALLY && (
															<Input
																color="white"
																value={ item?.email }
																name="email"
																label="Correo Electrónico"
																notMui
																disabled={ true }
															/>
														)
													}
													<div className="container-default" onClick={ () => {
														if (!item?.default)
															this.setDefault(item);
													} }>
														<p>Marcar como cuenta favorita</p>
														<div className={ `circle ${ item?.default ? 'active' : '' }` }></div>
													</div>
													<div className="row" style={{ marginTop: '10px' }}>
														<div className="col-md-6">
															<Button className="btn-delete" color="primary" type="button" onClick={ () => this.delete(item) }>
																Eliminar
															</Button>
														</div>
														<div className="col-md-6">
															<Button color="primary" type="button" onClick={ () => this.edit(item) }>
																Editar
															</Button>
														</div>
													</div>
												</div>
											</div>
										)
									})
								}
							</div>
						</div>
					</Render>

					{
						tab == TAB.INFO && (
							<div className="actions">
								<Button type="button" color="danger flat" onClick={() => this.deleteAccount()}>
									Eliminar Empresa
								</Button>
								<Button type="submit" color="primary">
									Guardar
								</Button>
							</div>
						)
					}
				</form>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Profile);